import React from 'react'
import PropTypes from 'prop-types'

import { Text } from '../..'
import { ErrorMessage } from '../..'

import styles from './FormField.module.scss'
import classNames from 'classnames'

const DefaultLabel = props => (
  <Text element='span' weight='semibold' color='inherit' {...props} />
)

const DefaultHint = props => (
  <Text size='s' color='heather' element='div' {...props} />
)

const Subtext = props => (
  <Text size='s' color='heather' element='div' {...props} />
)

const FormField = ({
  label,
  hint,
  name,
  input,
  labelIconButton,
  subtext,
  error,
  labelNode,
  labelContainerClassNames,
  containerClassNames,
  ...restProps
}) => {
  const InputComponent = input

  return (
    <div className={containerClassNames} data-qa='form-field'>
      <div className={classNames(styles.labelContainer)}>
        {label && (
          <DefaultLabel text={label} htmlFor={name} data-qa='form-field-label'>
            {label}
          </DefaultLabel>
        )}
        {labelIconButton ? labelIconButton : null}
        {hint && <DefaultHint data-qa='form-field-hint'>{hint}</DefaultHint>}
      </div>
      <InputComponent data-qa={`${name}-input`} name={name} {...restProps} />
      {subtext && <Subtext>{subtext}</Subtext>}
      {error && <ErrorMessage data-qa={`${name}-error`}>{error}</ErrorMessage>}
    </div>
  )
}

FormField.propTypes = {
  label: PropTypes.string,
  hint: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  name: PropTypes.string,
  input: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.node,
    PropTypes.elementType,
  ]).isRequired,
  labelIconButton: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.node,
    PropTypes.elementType,
  ]),
  subtext: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.node,
    PropTypes.elementType,
  ]),
  error: PropTypes.string,
}

export default FormField
